if (!customElements.get('cart-reviews-carousel')) {
  class CartReviewsCarousel extends HTMLElement {
    constructor() {
      super();
      this.sliderInstance = null;
      this.initialized = false;
      this.initAttempts = 0;
      this.maxAttempts = 10;
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.cart-reviews__items',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };

      this.classes = {
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
      
      if (!this.sliderWrapper) {
        console.error('Cart Reviews: Slider wrapper not found');
        return;
      }

      const slides = this.sliderWrapper.children;
      if (slides.length === 0) {
        console.warn('Cart Reviews: No review slides found');
        return;
      }

      console.log('Cart Reviews: Found', slides.length, 'slides');
      
      // Try to initialize
      this.attemptInit();
    }

    attemptInit() {
      this.initAttempts++;
      
      if (typeof window.FoxTheme !== 'undefined' && window.FoxTheme.Carousel) {
        console.log('Cart Reviews: FoxTheme.Carousel found, initializing...');
        this.initSlider();
      } else if (this.initAttempts < this.maxAttempts) {
        console.log('Cart Reviews: Waiting for FoxTheme... (attempt', this.initAttempts, ')');
        setTimeout(() => this.attemptInit(), 300);
      } else {
        console.error('Cart Reviews: FoxTheme.Carousel not available after', this.maxAttempts, 'attempts');
      }
    }

    initSlider() {
      if (this.initialized || this.sliderInstance) {
        console.log('Cart Reviews: Already initialized');
        return;
      }

      try {
        const prevBtn = this.querySelector(this.selectors.prevEl);
        const nextBtn = this.querySelector(this.selectors.nextEl);

        if (!prevBtn || !nextBtn) {
          console.error('Cart Reviews: Navigation buttons not found');
          return;
        }

        console.log('Cart Reviews: Buttons found, configuring swiper...');

        const sliderOptions = {
          slidesPerView: 1.5,
          spaceBetween: 16,
          
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },

          loop: false,
          centeredSlides: false,
          
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          
          breakpoints: {
            320: {
              slidesPerView: 1.15,
              spaceBetween: 12,
            },
            480: {
              slidesPerView: 1.2,
              spaceBetween: 14,
            },
            640: {
              slidesPerView: 1.5,
              spaceBetween: 16,
            },
          },
          
          speed: 400,
          threshold: 5,
          resistance: true,
          resistanceRatio: 0.85,
          
          watchOverflow: true,
          watchSlidesProgress: true,
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
        };

        // Add swiper classes
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        console.log('Cart Reviews: Creating Swiper instance...');

        // Initialize carousel
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();
        
        this.initialized = true;
        console.log('✅ Cart Reviews Carousel initialized successfully');
        
        // Update navigation state
        if (this.sliderInstance.slider) {
          this.sliderInstance.slider.on('slideChange', () => {
            this.updateNavigationState();
          });
          
          this.sliderInstance.slider.on('init', () => {
            console.log('Cart Reviews: Swiper init event fired');
            this.updateNavigationState();
          });
          
          // Initial state
          setTimeout(() => this.updateNavigationState(), 100);
        }
        
      } catch (error) {
        console.error('❌ Cart Reviews Carousel initialization error:', error);
        this.initialized = false;
      }
    }

    updateNavigationState() {
      const prevBtn = this.querySelector(this.selectors.prevEl);
      const nextBtn = this.querySelector(this.selectors.nextEl);
      
      if (!this.sliderInstance || !this.sliderInstance.slider) return;
      
      const slider = this.sliderInstance.slider;
      
      if (prevBtn) {
        if (slider.isBeginning) {
          prevBtn.classList.add('swiper-button-disabled');
          prevBtn.style.pointerEvents = 'none';
        } else {
          prevBtn.classList.remove('swiper-button-disabled');
          prevBtn.style.pointerEvents = 'auto';
        }
      }
      
      if (nextBtn) {
        if (slider.isEnd) {
          nextBtn.classList.add('swiper-button-disabled');
          nextBtn.style.pointerEvents = 'none';
        } else {
          nextBtn.classList.remove('swiper-button-disabled');
          nextBtn.style.pointerEvents = 'auto';
        }
      }
      
      console.log('Navigation state:', {
        isBeginning: slider.isBeginning,
        isEnd: slider.isEnd,
        activeIndex: slider.activeIndex
      });
    }

    disconnectedCallback() {
      if (this.sliderInstance && typeof this.sliderInstance.slider?.destroy === 'function') {
        try {
          this.sliderInstance.slider.destroy(true, true);
          console.log('Cart Reviews: Carousel destroyed');
        } catch (error) {
          console.error('Error destroying carousel:', error);
        }
        this.sliderInstance = null;
        this.initialized = false;
      }
    }
  }

  customElements.define('cart-reviews-carousel', CartReviewsCarousel);
  console.log('Cart Reviews Carousel: Custom element registered');
}
